import { defineStore } from 'pinia';
import { apiCreateLinkToken } from '@/api/ats-integrations';

export const useMergeStore = defineStore('merge', {
  state: () => ({
    linkToken: '',
    accountToken: '',
  }),
  actions: {
    async createLinkToken() {
      const { data, error } = await apiCreateLinkToken();

      if (!error) {
        this.linkToken = data.link_token;
      } else {
        console.error('Failed to create link token', error);
      }
    },
  },
});
